import t, { css as n } from "styled-components";
import { Text as e } from "./atoms-v243.js";
import { breakpoints as i } from "./atoms-v2125.js";
const s = t.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`, l = t(e)`
  color: ${({ $colorTheme: o, theme: r }) => r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o.get("tokens.body.productive").toJS()}

  @media ${i.medium} {
    ${({ theme: o }) => o.get("tokens.body.expressive").toJS()}
  }
`, c = t.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ $isLast: o }) => !o && n`
      margin-bottom: 8px;
    `}
`, g = t(e)`
  color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.secondary")};
  padding: 0 12px;
  ${({ theme: o }) => o.get("tokens.helper.productive").toJS()}

  @media ${i.medium} {
    ${({ theme: o }) => o.get("tokens.body.compact-productive").toJS()}
  }
`, x = t.div`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;

  &::before,
  &::after {
    background-color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.border.light.dark")};
    content: '';
    flex: 1;
    height: 1px;
  }
`;
export {
  s as Container,
  c as Day,
  g as DayLabel,
  x as DayLabelContainer,
  l as Title
};
